import { FaFacebook, FaGithub, FaInstagram } from "react-icons/fa";
// import { NavLink } from "react-router-dom";

export const Footer = () => {
    return (
        <div>
            <footer className="footer bg-dark py-6 pb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-3 mt-3">
                            <div className="text-primary text-center">
                                <a
                                    href="https://www.facebook.com/profile.php?id=100095109664953"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaFacebook size={30} />
                                </a>
                                <a
                                    href="https://github.com/dragonshifty"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaGithub size={30} />
                                </a>
                                <a
                                    href="https://www.instagram.com/dragonshifty/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaInstagram size={30} />
                                </a>
                            </div>
                        </div>
                        <div className="col-md-12 my-2 text-primary text-center">
                            <h6>© Dragonshifty Studios Ltd</h6>
                        </div>
                    </div>
                </div>
            </footer>

            {/* <footer className="d-flex flex-wrap justify-content-center align-items-center py-3 bg-dark">
                <div className="container">
                    <div className="row row-cols-3 row-cols-md-3 row-cols-lg-3 text-primary">
                        <div className="col">
                            <div className="d-flex align-items-center justify-content-center">
                                <p className="mb-0 text-white">

                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="d-flex align-items-center justify-content-center">
                                <p className="mb-0 text-white">
                                    © Dragonshifty Studios Ltd
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="d-flex align-items-center justify-content-center">
                                <a
                                    href="https://www.facebook.com/profile.php?id=100095109664953"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaFacebook size={30} />
                                </a>
                                <a
                                    href="https://github.com/dragonshifty"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaGithub size={30} />
                                </a>
                                <a
                                    href="https://www.instagram.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mx-2 text-primary"
                                >
                                    <FaInstagram size={30} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer> */}
        </div>
    );
};
